import React, { useState, useRef } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase/firestore"; // Adjust the path as needed
import styled from "styled-components";
import {
  PiHandTap,
  PiNotebookDuotone,
  PiSpinnerBallDuotone,
} from "react-icons/pi";
import Animate from "../Components/Animate";
import Spinner from "../Components/Spinner";
import { RiArrowRightSLine } from "react-icons/ri";
import { useUser } from "../context/userContext";
import Levels from "../Components/Levels";
import Exchanges from "../Components/Exchanges";
import SettingsMenu from "../Components/SettingsMenu";
import BoostHome from "../Components/BoostersHome";
import { MdLocationPin } from "react-icons/md";
import { NavLink } from "react-router-dom";
import RouletteGame from "../Components/RouletteGame";

const Container = styled.div`
  position: relative;
  display: flex;
  text-align: center;
  justify-content: center;
  width: 100%;
`;

const GoldHunters = () => {
  const imageRef = useRef(null);
  const [clicks, setClicks] = useState([]);
  const {
    balance,
    username,
    tapBalance,
    energy,
    userLevelss,
    fullName,
    id,
    mainTap,
    tapValue,
    setTapBalance,
    setBalance,
    refBonus,
    loading,
    multiplierSpin,
    chessePoints,
  } = useUser();

  const [points, setPoints] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [openClaim, setOpenClaim] = useState(false);
  const [congrats, setCongrats] = useState(false);
  const [pointOvelay, setPointOverlay] = useState(false);
  const [showLevel, setShowLevel] = useState(false);
  const [showExchange, setShowExchange] = useState(false);
  const [showSetting, setShowSetting] = useState(false);
  const [changeTap, setChangeTap] = useState(1);
  const [spinning, setSpinning] = useState(false);
  const [result, setResult] = useState(0);

  function triggerHapticFeedback() {
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (
      isIOS &&
      window.Telegram &&
      window.Telegram.WebApp &&
      window.Telegram.WebApp.HapticFeedback
    ) {
      console.log("Triggering iOS haptic feedback");
      window.Telegram.WebApp.HapticFeedback.impactOccurred("medium");
    } else if (isAndroid) {
      console.log("Android device detected");
      if ("vibrate" in navigator) {
        console.log("Vibration API supported, triggering haptic feedback");
        navigator.vibrate(50); // Vibrate for 50ms
      } else {
        console.warn("Vibration API not supported on this Android device");
      }
    } else {
      console.warn("Haptic feedback not supported on this device");
    }
  }

  const handleClaim = async (newPoint) => {
    const telegramUser = window.Telegram.WebApp.initDataUnsafe?.user;
    if (telegramUser) {
      const { id: userId } = telegramUser;
      const userRef = doc(db, "telegramUsers", userId.toString());
      try {
        // Prepare the update data
        const updateData = {
          balance: balance + newPoint,
          tapBalance: tapBalance + newPoint,
        };

        // Only update energy if multiplierSpin is not greater than 0
        if (multiplierSpin <= 0) {
          updateData.energy = energy - changeTap; // Update energy only if multiplierSpin is 0
        }

        await updateDoc(userRef, updateData);
        setBalance((prevBalance) => prevBalance + newPoint);
        setTapBalance((prevTapBalance) => prevTapBalance + newPoint);
        // setPointOverlay(true);
        setPointOverlay(true);
        console.log("Points claimed successfully");
      } catch (error) {
        console.error("Error updating balance and energy:", error);
      }
    }
    openClaimer();
  };

  const openClaimer = () => {
    setOpenClaim(true);
    // setCongrats(true);
    setClicks([]);

    setTimeout(() => {
      setCongrats(false);
    }, 4000);
  };

  const formatNumber = (num) => {
    if (num < 100000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ");
    } else if (num < 1000000) {
      return new Intl.NumberFormat().format(num).replace(/,/g, " ");
    } else {
      return (num / 1000000).toFixed(3).replace(".", ".") + " M";
    }
  };

  const initialLevelIndex = userLevelss.findIndex(
    (level) => tapBalance < level.tapBalanceRequired
  );
  const currentLevelIndex =
    initialLevelIndex === -1 ? userLevelss.length - 1 : initialLevelIndex;

  const displayedLevelIndex = currentLevelIndex;
  const currentLevel = userLevelss[displayedLevelIndex];

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <Animate>
          <div className="w-full flex justify-center flex-col">
            <div className="w-full flex items-center justify-between h-[55px] px-4 bg-[#000] border-b border-b-[2px] border-b-[#a71414]">
              <div className="min-w-[50%] flex items-center space-x-[6px]">
                <div
                  className={`w-[30px] h-[30px] rounded-[8px] p-[2px] overflow-hidden flex items-center justify-center relative`}
                >
                  <img
                    src={currentLevel.icon}
                    className={`w-[30px] mt-[6px]`}
                    alt={fullName || "user"}
                  />
                </div>

                <div className="w-[70%] flex flex-col space-y-1 pr-4">
                  <div className="w-full flex justify-between text-[10px] font-medium items-center">
                    <span className="levelName flex items-center">
                      <span onClick={() => setShowLevel(true)} className="">
                        {currentLevel.name}
                      </span>
                      <span className="flex items-center">
                        {" "}
                        <RiArrowRightSLine
                          size={12}
                          className="mt-[1px]"
                        />{" "}
                      </span>
                    </span>

                    <span className="">Cheesy {username}</span>
                  </div>

                  <div className="flex w-full mt-2 items-center bg-[#56565630] rounded-[10px] border-[1px] border-[#49494952]">
                    <div
                      className={`h-[6px] rounded-[8px] levelbar`}
                      style={{
                        width: `${
                          (tapBalance / currentLevel.tapBalanceRequired) * 100
                        }%`,
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="flex w-[50%] mb-[-4px] rounded-full items-center justify-end">
                <div className="flex flex-col items-center justify-center">
                  <p className="text-[9px]">Spin per tap</p>
                  <div className="flex items-center justify-center space-x-1 text-[11px]">
                    <span className="flex items-center justify-center">
                      <img src="/coin.webp" alt="ppf" className="w-[10px]" />
                    </span>
                    <span className="font-bold">{tapValue.value}</span>
                  </div>
                </div>
              </div>
            </div>

            {/*  */}

            <div
              id="refer"
              className="w-full flex flex-col scroller h-[100vh] overflow-y-auto pb-[180px] pt-3 px-4"
            >
              <div className="w-full flex pt-2 items-center justify-between space-x-5 px-4">
                <div className="text-[#dddddd] w-[42%] flex space-x-1 items-center rounded-[6px] text-[15px] font-medium">
                  <span className="text-[16px]">
                    <PiHandTap
                      size={18}
                      className="tesxt-[#bcbcbc] text-accent"
                    />
                  </span>
                  <span className="text-nowrap">{energy} Spins Left</span>
                </div>

                <NavLink
                  to="/airdrop"
                  className="text-[#dddddd] w-[50%] flex space-x-1 items-center justify-end rounded-[6px] text-[15px] font-medium"
                >
                  <img src="/ton.png" alt="ccx" className="w-[16px]" />
                  <span className="text-nowrap text-[#cfefff]">
                    Connect Wallet
                  </span>
                </NavLink>
              </div>

              {/*  */}

              <h1 className="flex w-full justify-center items-center space-x-1 pt-2 pb-3">
                <img
                  src="/cheesetoken.png"
                  className="w-[30px]"
                  alt="engagecoin"
                />
                <span className="text-[#fff] text-[32px] font-bold">
                  <span className="pl-[2px]">
                    {formatNumber(balance + refBonus)}{" "}
                    {/* <span className="text-accent">CHEESE</span> */}
                  </span>
                </span>
              </h1>
              <div className="w-full relative flex justify-center items-center pt-4 pb-4 clickContainer">
                <div className="absolute top-0 left-0 flex items-center rounded-full bg-[#A71414] space-x-2">
                  <button
                    onClick={() =>
                      setChangeTap((prev) => (prev - 1 < 1 ? 1 : prev - 1))
                    }
                    className="bg-white/20 hover:bg-gray-700 text-white text-[10px] font-bold py-2 px-3 rounded-full"
                  >
                    -
                  </button>
                  <span className="text-white text-[12px] font-light">
                    {changeTap}+ spins
                  </span>
                  <button
                    onClick={() => setChangeTap((prev) => prev + 1)}
                    className="bg-white/20 hover:bg-gray-700 text-white text-[10px] font-bold py-2 px-3 rounded-full"
                  >
                    +
                  </button>
                </div>
                <div
                  id="loaderan"
                  className="w-[350px] relative flex items-center justify-center"
                >
                  {mainTap && (
                    <Container>
                      <RouletteGame
                        triggerHapticFeedback={triggerHapticFeedback}
                        setIsDisabled={setIsDisabled}
                        imageRef={imageRef}
                        setPoints={setPoints}
                        handleClaim={handleClaim}
                        setClicks={setClicks}
                        spinning={spinning}
                        setSpinning={setSpinning}
                        result={result}
                        setResult={setResult}
                        changeTap={changeTap}
                        setShowAlert={setShowAlert}
                      />
                    </Container>
                  )}
                  <div className="grid place-items-center w-10 h-10 bg-[#A71414] absolute right-0 top-0 rounded-full">
                    <span className="text-center justify-center m-0 text-xs font-medium">
                      x{tapValue.value}
                    </span>
                  </div>
                </div>
              </div>

              <div className="w-full flex justify-between items-center pb-4">
                <div className="flex items-center">
                  <span className="flex items-center">
                    <img
                      src="/cheesespin.png"
                      className="w-[18px]"
                      alt="engagecoin"
                    />
                  </span>
                  <span className="text-[#fff] font-semibold text-[16px]">
                    <span className="pl-[2px]">
                      {points} <span className="text-accent"></span>
                    </span>
                  </span>
                </div>
                {multiplierSpin > 0 && (
                  <div className="grid place-items-center px-3 w-fit h-10 bg-[#A71414] rounded-[12px]">
                    <span className="text-center justify-center m-0 text-xs font-medium">
                      3x boost for {multiplierSpin} spin count
                    </span>
                  </div>
                )}
              </div>
              {/* bg-[#6e6e6e33] */}
              <div className="w-full bg-[#000] border border-[2px] border-[#a71414] rounded-[14px] flex flex-col py-2">
                <div className="w-full flex justify-between items-center border-b border-[#49494952] py-2 px-4">
                  <div className="flex items-center">
                    <span className="flex items-center mt-[-1px] pr-1">
                      <img
                        src="/cheesetoken.png"
                        className="w-[18px]"
                        alt="engagecoin"
                      />
                    </span>
                    <span className="text-[#fff] font-semibold text-[16px]">
                      <span className="pl-[2px]">
                        {chessePoints}{" "}
                        <span className="text-accent">$CHEESE</span>
                      </span>
                    </span>
                  </div>

                  <div className="flex items-center cursor-pointer space-x-1 text-[13px]">
                    <a
                      href="https://app.cheeseart.io"
                      rel="noreferrer"
                      target="_blank"
                    >
                      <span className="px-[16px] py-[4px] bg-white/20 rounded-[8px] hover:bg-white/60">
                        Be Yourself
                      </span>
                    </a>
                  </div>
                </div>
                <div className="m-2"></div>

                <div className="w-full pt-0">
                  <BoostHome />
                </div>
              </div>

              {/*  */}

              <div className="w-full flex items-center justify-between  space-x-2 pt-4 pb-2">
                <NavLink
                  to="/checkin"
                  className="bg-[#000] border border-[2px] border-[#a71414] p-4 h-[85px] w-[32%] rounded-[10px] text-center text-nowrap space-y-1 text-[11px] font-medium flex flex-col items-center justify-center relative"
                >
                  <MdLocationPin
                    size={28}
                    className="w-[30px] text-green-500"
                  />
                  <h3 className="">Daily checkin</h3>
                </NavLink>

                <NavLink
                  to="/ghand"
                  className="bg-[#000] border border-[2px] border-[#a71414] p-4 h-[85px] w-[32%] rounded-[10px] text-center text-nowrap space-y-1 text-[11px] font-medium flex flex-col items-center justify-center relative"
                >
                  <PiSpinnerBallDuotone
                    size={24}
                    className="w-[30px] text-orange-500"
                  />
                  <h3 className="">Gold Hand</h3>
                </NavLink>

                <NavLink
                  to="/tasks"
                  className="bg-[#000] border border-[2px] border-[#a71414] p-4 h-[85px] w-[32%] rounded-[10px] text-center text-nowrap space-y-1 text-[11px] font-medium flex flex-col items-center justify-center relative"
                >
                  <PiNotebookDuotone
                    size={24}
                    className="w-[30px] text-purple-500"
                  />
                  <h3 className="">Activities</h3>
                </NavLink>
              </div>
            </div>

            {/* Claim Modal */}
            <div className="w-full absolute top-[50px] flex justify-center z-50 pointer-events-none select-none">
              {congrats ? (
                <img src="/congrats.gif" alt="congrats" className="w-[80%]" />
              ) : (
                <></>
              )}
            </div>

            <Exchanges
              showExchange={showExchange}
              setShowExchange={setShowExchange}
            />
            <Levels showLevel={showLevel} setShowLevel={setShowLevel} />
            <SettingsMenu
              showSetting={showSetting}
              setShowSetting={setShowSetting}
            />
          </div>
        </Animate>
      )}
      {showAlert && (
        <div
          className="flex items-center justify-center w-full absolute bottom-0 left-0 z-[1000] transition-all duration-1000 ease-in-out"
          style={{
            opacity: showAlert ? 1 : 0,
            transform: showAlert ? "translateY(0)" : "translateY(100%)",
          }}
        >
          <div className="w-[80%] bg-btn4 p-4 rounded-lg">
            <p className="text-[12px] text-center text-white">
              The spin increase you provide is more than the number of spins or
              3x boost spins, please reduce the number of spins left.
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default GoldHunters;
